
import { Injectable } from '@angular/core';
import { ReportItemModel } from './ReportItemModel';
import { CombeniaService } from '../services/CombeniaService/CombeniaService';
import * as cloneDeep from 'lodash/cloneDeep';
import * as moment from 'moment';
import { AppConst } from '../services/CombeniaService/consts/AppConsts';
@Injectable()
export class ReportModel {

    /* supplier brand store main cust */
    public FILTER_LIST: Array<any> = [
        {
            id: 'supplier_all',
            title: 'SUPPLIER',
            criteria: "suppliers",
            type: 'select',
            selected: [],
            children: ["brand_ker", "brand_comp", "brand_all"]

        }, {
            id: 'supplier_comp',
            title: 'SUPPLIER',
            criteria: "suppliers",
            type: 'select',
            selected: [],
            children: ["brand_ker", "brand_comp", "brand_all"]

        }, {
            id: 'period',
            title: 'PERIOD',
            type: 'dateRange',
        }, {
            id: 'periodMonth',
            title: 'PERIOD',
            type: 'dateRange',
        },{
            id: 'brand_ker',
            title: 'BRAND',
            type: 'select',
            criteria: "brands",
            selected: []
        }, {
            id: 'brand_all',
            title: 'BRAND',
            type: 'select',
            criteria: "brands",
            selected: []
        }, {
            id: 'brand_comp',
            title: 'BRAND',
            type: 'select',
            criteria: "brands",
            selected: []
        }, {
            id: 'store',
            title: 'STORE',
            type: 'select',
            criteria: "stores",
            selected: []
        }, {
            id: 'sales_org',
            title: 'SALES_ORG',
            type: 'select',
            criteria: "sales_orgs",
            selected: []
        },
        {
            id: 'distr_ch',
            title: 'DIST_CH',
            type: 'select',
            criteria: "distr_chs",
            selected: []
        },
        {
            id: 'country',
            title: 'COUNTRY',
            type: 'select',
            criteria: "countries",
            selected: []
        },
        {
            id: 'main_customer',
            title: 'MAIN_CUSTOMER',
            type: 'select',
            criteria: "mccodes",
            selected: [],
            children: ["store"]

        },
        {
            id: 'user_orders',
            title: 'USERNAME',
            type: 'select',
            criteria: "users",
            selected: []
        },
        {
            id: 'group_dual',
            title: 'GROUP_DUAL',
            type: 'check',
            criteria: "group_dual"
            
        }
    ];

    public REPORT_LIST: Array<any> = [
        new ReportItemModel({
            id: 'sellout',
            title: 'SELLOUT',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'column',
            children: [
                new ReportItemModel({
                    id: 'sellout_by_suppliers',
                    title: 'REPORT.sellout_by_supplier',
                    type: 'table',
                    total: ['quantity', 'price_value'],
                    columns: [
                        { id: 'rank', title: '#', type: 'number' },
                        { id: 'id_supplier', title: 'SUPPLIER', type: 'string', sortable: true },
                        { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                        { id: 'price_value', title: 'VALUE', type: 'price', sortable: true }
                    ],
                }),
                new ReportItemModel({
                    id: 'sellout_by_brand',
                    title: 'REPORT.sellout_by_brand',
                    type: 'table',
                    total: ['quantity', 'price_value'],
                    columns: [
                        { id: 'rank', title: '#', type: 'number' },
                        { id: 'id_supplier', title: 'SUPPLIER', type: 'string', sortable: true },
                        { id: 'brand_code', title: 'BRAND', type: 'string', sortable: true },
                        { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                        { id: 'price_value', title: 'VALUE', type: 'price', sortable: true }
                    ],
                })
            ]
        }),
        new ReportItemModel({
            id: 'sales_trends',
            title: 'REPORT.sales_trends',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('group_dual')
            ],
            view: 'row',
            children: [
                new ReportItemModel({
                    id: 'sales_trends_by_brand',
                    exportId: 'salesByBrand',
                    title: 'REPORT.sales_by_brand',
                    type: 'chart',
                    chartType: 'pie',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                }),
                new ReportItemModel({
                    id: 'daily_sales',
                    exportId: 'dailySales',
                    title: 'REPORT.daily_sales',
                    type: 'chart',
                    chartType: 'line',
                    implicitFilter: {
                        suppliers: ['KERING']
                    }
                }),
                new ReportItemModel({
                    id: 'sales_by_store',
                    exportId: 'salesByPos',
                    title: 'REPORT.sales_by_pos',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'door_name',
                    yAxis: 'price_value',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        limit: 8,
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                })
            ]
        }),
        new ReportItemModel({
            id: 'sales_trends_with_competition',
            title: 'REPORT.sales_trends_with_competition',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('group_dual')
            ],
            view: 'row',
            children: [
                new ReportItemModel({
                    id: 'sales_trends_by_brand',
                    title: 'REPORT.top_10_brands',
                    exportId: 'topTen',
                    type: 'chart',
                    chartType: 'pie',
                    implicitFilter: {
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                }),
                new ReportItemModel({
                    id: 'daily_sales',
                    title: 'REPORT.daily_sales',
                    exportId: 'dailySales',
                    type: 'chart',
                    chartType: 'line',
                    xAxis: 'date',
                    yAxis: 'value'
                }),
                new ReportItemModel({
                    id: 'sales_trends_by_brand',
                    title: 'REPORT.sales_by_brand',
                    exportId: 'salesByBrand',
                    type: 'chart',
                    chartType: 'bar',
                    maxItem: 8,
                    xAxis: 'brand_code',
                    yAxis: 'price_value',
                    implicitFilter: {
                        order_column: 'price_value',
                        sort: 'desc',
                        limit: 8
                    }
                })
            ]
        }),
        new ReportItemModel({
            id: 'best_sellers',
            title: 'REPORT.best_sellers',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'wide',
            columns: [
                { id: 'rank', title: '#', type: 'number' },
                { id: 'brand_code', title: 'BRAND', type: 'string' },
                { id: 'door_name', title: 'STORE', type: 'string' },
                { id: 'article_name', title: 'SKU', type: 'string' },
                { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                { id: 'price_value', title: 'VALUE', type: 'price', sortable: true },
                { id: 'month_of_stock', title: 'MONTHS_OF_STOCK', type: 'number', sortable: true }
            ],
            dynamicOrder: true,
            implicitFilter: {
                limit: 50,
                order_column: 'price_value',
                sort: 'desc'
            }
        }),
        new ReportItemModel({
            id: 'popular_characteristics_color',
            title: 'REPORT.popular_characteristics_color',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('group_dual')
            ],
            view: 'grid',
            children: [
                new ReportItemModel({
                    id: 'popular_char.front_main_col_desc',
                    title: 'REPORT.front_main_col_desc',
                    exportId: 'frontMainColors',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'front_main_col_desc',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'front_main_col_desc'
                    }
                }),
                new ReportItemModel({
                    id: 'popular_char.temple_main_col_descr',
                    title: 'REPORT.temple_main_col_descr',
                    exportId: 'templeMainColors',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'temple_main_col_descr',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'temple_main_col_descr'
                    }
                }),
                new ReportItemModel({
                    id: 'popular_char.lens_main_col_descr',
                    title: 'REPORT.lens_main_col_descr',
                    exportId: 'lensMainColors',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'lens_main_col_descr',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'lens_main_col_descr'
                    }
                }),
                new ReportItemModel({
                    id: 'popular_char.shape_descr',
                    title: 'REPORT.shape_descr',
                    exportId: 'shapes',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'shape_descr',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'shape_descr'
                    }
                }),
            ]
        }),
        new ReportItemModel({
            id: 'popular_characteristics_material',
            title: 'REPORT.popular_characteristics_material',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('group_dual')
            ],
            view: 'grid',
            children: [
                new ReportItemModel({
                    id: 'popular_char.front_main_mat_descr',
                    title: 'REPORT.front_main_mat_descr',
                    exportId: 'frontMainMaterials',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'front_main_mat_descr',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'front_main_mat_descr'
                    }
                }),
                new ReportItemModel({
                    id: 'popular_char.temple_main_mat_descr',
                    title: 'REPORT.temple_main_mat_descr',
                    exportId: 'templeMainMaterials',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'temple_main_mat_descr',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'quantity',
                        sort: 'desc',
                        char: 'temple_main_mat_descr'
                    }
                }),
                new ReportItemModel({
                    id: 'popular_price',
                    title: 'REPORT.price',
                    exportId: 'price',
                    type: 'chart',
                    chartType: 'bar',
                    xAxis: 'price_range',
                    yAxis: 'quantity',
                    implicitFilter: {
                        suppliers: ['KERING'],
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                }),
            ]
        }),
        new ReportItemModel({
            id: 'stock',
            title: 'REPORT.stock',
            filters: [
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'wide',
            hasPagination: true,
            dynamicOrder: true,
            columns: [
                { id: 'brand_code', title: 'BRAND', type: 'string' },
                { id: 'article_name', title: 'SKU', type: 'string' },
                { id: 'door_name', title: 'STORE', type: 'string' },
                { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                { id: 'price_value', title: 'VALUE', type: 'price', sortable: true },
                { id: 'month_of_stock', title: 'MONTHS_OF_STOCK', type: 'number', sortable: true },
                { id: 'sellout', title: 'RANKING_SELLOUT', type: 'number' }
            ],
            implicitFilter: {
                order_column: 'price_value',
                sort: 'DESC',
                limit: 100
            }
        }),
        new ReportItemModel({
            id: 'stock_charts',
            title: 'REPORT.stock_charts',
            filters: [
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('brand_ker'),
                this.getFilterDefinition('group_dual')
            ],
            view: 'three',
            children: [
                new ReportItemModel({
                    id: 'stock_by_brand',
                    title: 'REPORT.stock_by_brand',
                    exportId: 'stockByBrand',
                    type: 'chart',
                    chartType: 'pie'
                }),
                new ReportItemModel({
                    id: 'month_of_stock_by_brand',
                    title: 'REPORT.months_of_stock_by_brand',
                    exportId: 'monthsOfStockByBrand',
                    type: 'chart',
                    chartType: 'bar',
                    maxItem: 8,
                    xAxis: 'brand_code',
                    yAxis: 'month_of_stock',
                    dynamicOrder: true,
                    implicitFilter: {
                        limit: 8,
                        order_column: 'month_of_stock',
                        sort: 'desc'
                    }
                }),
                new ReportItemModel({
                    id: 'month_of_stock_by_store',
                    title: 'REPORT.months_of_stock_by_store',
                    exportId: 'monthsOfStockByStore',
                    type: 'chart',
                    chartType: 'bar',
                    maxItem: 8,
                    xAxis: 'door_name',
                    yAxis: 'month_of_stock',
                    dynamicOrder: true,
                    implicitFilter: {
                        limit: 8,
                        order_column: 'month_of_stock',
                        sort: 'desc'
                    }
                })
            ]
        }),
        new ReportItemModel({
            id: 'sales_data_competition',
            title: 'REPORT.sales_data_with_competition',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'wide',
            hasPagination: true,
            dynamicOrder: true,
            columns: [
                { id: 'selling_date', title: 'DATE', type: 'date', format: 'DD/MM/YYYY', sortable: true },
                { id: 'id_supplier', title: 'SUPPLIER', type: 'string', sortable: true },
                { id: 'brand_code', title: 'BRAND', type: 'string', sortable: true },
                { id: 'door_name', title: 'STORE', type: 'string', sortable: true },
                { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                { id: 'price_value', title: 'VALUE', type: 'price', sortable: true }
            ],
            implicitFilter: {
                order_column: 'selling_date',
                sort: 'desc',
                limit: 100
            }
        }),
        new ReportItemModel({
            id: 'sales_data_competition_vs_last_year',
            title: 'REPORT.sales_data_with_competition_vs_last_year',
            filters: [
                this.getFilterDefinition('periodMonth'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'wide',
            hasPagination: true,
            columns: [
                { id: 'id_supplier', title: 'SUPPLIER', type: 'string' },
                { id: 'brand_code', title: 'BRAND', type: 'string' },
                { id: 'door_name', title: 'STORE', type: 'string' },
                { id: 'selling_date', title: 'DATE', type: 'date' },
                { id: 'prev_year_quantity', title: 'QTY_LASTYEAR', type: 'number' },
                { id: 'curr_year_quantity', title: 'QTY_NOW', type: 'number' },
                { id: 'quantity_perc', title: 'QTY_PERC', type: 'perc' },
                { id: 'prev_year_price_value', title: 'VALUE_LASTYEAR', type: 'price' },              
                { id: 'curr_year_price_value', title: 'VALUE_NOW', type: 'price' },
                { id: 'price_perc', title: 'VALUE_PERC', type: 'perc'}
            ],
            implicitFilter: {
                order_column: 'selling_date',
                sort: 'DESC'
            }
        }),
        new ReportItemModel({
            id: 'suppliers_by_store',
            title: 'REPORT.brand_company_ranking_by_store',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),              
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'wide',
            hasTotal: true,
            columns: [
                { id: 'rank', title: '#', type: 'string' },
                { id: 'door_name_city', title: 'STORE', type: 'string', sortable: true },
                { id: 'id_supplier', title: 'SUPPLIER', type: 'string', sortable: true },
                { id: 'quantity', title: 'QTY', type: 'number' },
                { id: 'price_value', title: 'VALUE', type: 'price', sortable: true }
            ],
            implicitFilter: {
                order_column: 'price_value',
                sort: 'desc'
            }
        }),
        new ReportItemModel({
            id: 'top_10_rankings_by_store',
            title: 'REPORT.top_10_rankings_by_store',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('supplier_all'),
                this.getFilterDefinition('group_dual')
            ],
            type: 'table',
            view: 'row',
            children: [
                new ReportItemModel({
                    id: 'suppliers_by_store',
                    topRanking:true,
                    title: 'REPORT.top_10_suppliers_by_store',
                    type: 'table',
                    total: ['rank1', 'rank2', 'rank3', 'rank4', 'rank5', 'rank6', 'rank7', 'rank8', 'rank9', 'rank10'],
                    columns: [
                        { id: 'store', title: 'STORE', type: 'string', sortable: true },
                        { id: 'rank1', title: '#1', type: 'string' },
                        { id: 'rank2', title: '#2', type: 'string' },
                        { id: 'rank3', title: '#3', type: 'string' },
                        { id: 'rank4', title: '#4', type: 'string' },
                        { id: 'rank5', title: '#5', type: 'string' },
                        { id: 'rank6', title: '#6', type: 'string' },
                        { id: 'rank7', title: '#7', type: 'string' },
                        { id: 'rank8', title: '#8', type: 'string' },
                        { id: 'rank9', title: '#9', type: 'string' },
                        { id: 'rank10', title: '#10', type: 'string' }
                    ],
                    implicitFilter: {
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                }),
                new ReportItemModel({
                    id: 'brands_by_store',
                    title: 'REPORT.top_10_brands_by_store',
                    topRanking:true,
                    type: 'table',
                    total: ['rank1', 'rank2', 'rank3', 'rank4', 'rank5', 'rank6', 'rank7', 'rank8', 'rank9', 'rank10'],
                    columns: [
                        { id: 'store', title: 'STORE', type: 'string', sortable: true },
                        { id: 'rank1', title: '#1', type: 'string' },
                        { id: 'rank2', title: '#2', type: 'string' },
                        { id: 'rank3', title: '#3', type: 'string' },
                        { id: 'rank4', title: '#4', type: 'string' },
                        { id: 'rank5', title: '#5', type: 'string' },
                        { id: 'rank6', title: '#6', type: 'string' },
                        { id: 'rank7', title: '#7', type: 'string' },
                        { id: 'rank8', title: '#8', type: 'string' },
                        { id: 'rank9', title: '#9', type: 'string' },
                        { id: 'rank10', title: '#10', type: 'string' }
                    ],
                    implicitFilter: {
                        order_column: 'price_value',
                        sort: 'desc'
                    }
                })
            ]
        }),
        new ReportItemModel({
            id: 'store_to_store',
            title: 'REPORT.store_to_store',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('main_customer'),
                
            ],
            type: 'table',
            view: 'wide',
            columns: [
                { id: 'rank', title: '#', type: 'string' },
                { id: 'sender_store_name', title: 'SENDER', type: 'string' },
                { id: 'recipient_store_name', title: 'RECIPIENT', type: 'string' },
                { id: 'reason_of_change', title: 'REASON_OF_CHANGE', type: 'string' },
                { id: 'article_name', title: 'SKU', type: 'string' },
                { id: 'quantity_sent', title: 'QUANTITY', type: 'number', sortable: true },
                { id: 'creation_date', title: 'DATE', type: 'date', format: 'DD/MM/YYYY', sortable: true }
            ]
        }),
        new ReportItemModel({
            id: 'sales_details',
            title: 'REPORT.sales_details',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('user_orders'),
                this.getFilterDefinition('group_dual')
            ], 
            type: 'table',
            view: 'wide',
            hasPagination: true,
            dynamicOrder: true,
            columns: [
                { id: 'order_date', title: 'DATE', type: 'date', format: 'DD/MM/YYYY', sortable: true },
                { id: 'main_cust_description', title: 'MAIN_CUSTOMER', type: 'string', sortable: true },
                { id: 'door_name', title: 'STORE', type: 'string', sortable: true },
                { id: 'username', title: 'USERNAME', type: 'string', sortable: true  },
                { id: 'brand_code', title: 'BRAND', type: 'string', sortable: true },
                { id: 'sku', title: 'SKU', type: 'string', sortable: true },
                { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                { id: 'price_value', title: 'SELLOUT_VALUE', type: 'price', sortable: true },
            ],
            implicitFilter: {
                order_column: 'order_date',
                sort: 'desc',
                limit: 50
            }
        }),
        new ReportItemModel({
            id: 'competitor_sales_details',
            title: 'REPORT.competitors_sales_details',
            filters: [
                this.getFilterDefinition('period'),
                this.getFilterDefinition('sales_org'),
                this.getFilterDefinition('distr_ch'),
                this.getFilterDefinition('country'),
                this.getFilterDefinition('brand_all'),
                this.getFilterDefinition('main_customer'),
                this.getFilterDefinition('store'),
                this.getFilterDefinition('user_orders'),
                this.getFilterDefinition('group_dual')
            ], 
            type: 'table',
            view: 'wide',
            hasPagination: true,
            dynamicOrder: true,
            columns: [
                { id: 'order_date', title: 'DATE', type: 'date', format: 'DD/MM/YYYY', sortable: true },
                { id: 'main_cust_description', title: 'MAIN_CUSTOMER', type: 'string', sortable: true },
                { id: 'door_name', title: 'STORE', type: 'string', sortable: true },
                { id: 'username', title: 'USERNAME', type: 'string', sortable: true  },
                { id: 'brand_code', title: 'BRAND', type: 'string', sortable: true },
                { id: 'quantity', title: 'QTY', type: 'number', sortable: true },
                { id: 'price_value', title: 'SELLOUT_VALUE', type: 'price', sortable: true },
            ],
            implicitFilter: {
                order_column: 'order_date',
                sort: 'desc',
                limit: 50
            }
        })

    ];


    public constructor(
        public combenia: CombeniaService
    ) {

    }

    getReportList() {
        return cloneDeep(this.REPORT_LIST);
    }

    getFilterDefinition(id: string) {
        let list = cloneDeep(this.FILTER_LIST);
        return list.find((rep) => {
            return rep.id === id;
        });
    }

    getReport(id: string) {
        return cloneDeep(this.REPORT_LIST).find((rep) => {
            return rep.id === id;
        });
    }

    getSubReports(id: string): Array<any> {
        let report = this.getReport(id);
        let result = [];
        if (report) {
            if (report.columns || report.type === 'chart') {
                result.push(report);
            } else if (report.children) {
                for (let item of report.children) {
                    if (item.columns || item.type === 'chart') {
                        result.push(item);
                    }
                }
            }
        }
        return result;
    }

    getReportData(report, filter?: any): Promise<any> {
        var promise = new Promise((resolve, reject) => {

            let dummy = report.type === 'table' ? this.getDummyDataTable(report) : this.getDummyDataPie(report);
            filter = filter ? filter : {};
            if(report.id.indexOf('popular_char') !== -1) {
                filter.action = 'popular_char'
            } else {
                filter.action = report.id;
            }
            if(report.id === 'sales_data_competition_vs_last_year') {
                filter.date_from = filter.date_from.substring(3,10);
                filter.date_to = filter.date_to.substring(3,10)
                let dateFrom = filter.date_from;
                let diffDate = moment(filter.date_to, "MM/YYYY").diff(moment(filter.date_from, "MM/YYYY"), "months");
                if(diffDate > 0 && AppConst.REPORT_N_OF_PAGE == -1) {
                    filter.date_from = filter.date_to;
                    AppConst.REPORT_N_OF_PAGE = diffDate;
                    AppConst.REPORT_RANGE = filter.date_from;
                    AppConst.REPORT_START_DATE = dateFrom;
                }
            }
            if (report.implicitFilter) {
                filter = { ...report.implicitFilter, ...filter };
            }
            this.combenia.readEntity('reports', filter).then(res => {
                resolve(res ? res : dummy);
            });
        });
        return promise;
    }

    getTopRankingsByStore(report, res) {
        return new Promise((resolve) => {
            let newResponse = [];
            let tmpObj = {};
            let rankBy = report.id === 'brands_by_store' ? 'brand_code' : 'id_supplier';

            /* Group by store */
            res.forEach(item => {
                if (tmpObj[item.door_name]) {
                    tmpObj[item.door_name].push(item[rankBy]);
                } else {
                    tmpObj[item.door_name] = [item[rankBy]];
                }
            });

            for (let i in tmpObj) {
                if (tmpObj[i].length > 0) {
                    let obj = { store: i };
                    tmpObj[i].forEach((item, index) => {
                        obj['rank' + (index + 1)] = item;
                    });
                    newResponse.push(obj);
                }
            }
            resolve(newResponse);
        });
    }


    getTotal(report, data) {
        let total = {};

        for (let col of report.columns) {
            if (col.id !== 'rank') {
                total[col.id] = 'TOTAL';
                break;
            }
        }
        if (report.topRanking) {
            let arr: any = [];
            let groupBy = report.id === 'suppliers_by_store' ? 'id_supplier' : 'brand_code';
            /* Group by supplier or brand */
            data.forEach((elem) => {
                let key = elem[groupBy];
                const idx = arr.findIndex(item => item.label === key);
                if (idx !== -1) {
                    arr[idx].price_value += elem.price_value;
                } else {
                    arr.push({ label: key, price_value: elem.price_value });
                }
            });
            /* Sort */
            arr.sort((a, b) => a.price_value < b.price_value ? 1 : a.price_value > b.price_value ? -1 : 0);
            /* Render data for table */
            report.total.forEach((item, index) => {
                if (arr[index]) {
                    total[item] = arr[index].label;
                }
            });
        } else {
            data.forEach((elem) => {
                for (let key of report.total) {
                    total[key] = total[key] ? total[key] + elem[key] : elem[key];
                }
            });
        }
        return total;
    }


    getDummyDataTable(report): any {
        let dummy = [];
        for (let i = 1; i < 30; i++) {
            dummy.push({
                rank: i,
                store: 'LOTTE BUSAN',
                supplier: 'KER',
                brand: 'GUC',
                qty: 1000 + i,
                value: 100000 + i,
                sku: 'SC0123-0' + i,
                monthstock: 6.8,
                price: 1000 + i,
                ranking: 100
            });
        }
        return dummy;
    }

    getDummyDataPie(report): any {
        let dummy = [];

        for (let i = 0; i < 10; i++) {
            dummy.push({ value: i + '%', title: 'Lorem ipsum' + i });
        }
        dummy.push({ value: '10%', title: 'Other' });
        return dummy;
    }

}
